import retry from '@wix/da-shared-react/pkg/utils/webpack/chunkRetry';
import React, { lazy } from 'react';
import { isValidNotification } from './validator';
const ErrorNotification = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "ncmsgs" */ './Types/ErrorNotification')));
const WatchNotification = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "ncmsgs" */ './Types/WatchNotification')));
const FaveNotification = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "ncmsgs" */ './Types/FaveNotification')));
const CollectNotification = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "ncmsgs" */ './Types/CollectNotification')));
const PrivateCollectNotification = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "ncmsgs" */ './Types/PrivateCollectNotification')));
const CommentBadgeAwardNotification = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "ncmsgs" */ './Types/CommentBadgeAwardNotification')));
const DeviationBadgeAwardNotification = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "ncmsgs" */ './Types/DeviationBadgeAwardNotification')));
const BadgeNotification = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "ncmsgs" */ './Types/BadgeNotification')));
const BadgeLevelledNotification = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "ncmsgs" */ './Types/BadgeLevelledNotification')));
const DdToAuthorNotification = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "ncmsgs" */ './Types/DdToAuthorNotification')));
const DdToSuggesterNotification = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "ncmsgs" */ './Types/DdToSuggesterNotification')));
const CommentMentionsDeviation = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "ncmsgs" */ './Types/CommentMentionsDeviation')));
const CommentMentionsUser = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "ncmsgs" */ './Types/CommentMentionsUser')));
const DeviationMentionsDeviation = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "ncmsgs" */ './Types/DeviationMentionsDeviation')));
const DeviationMentionsUser = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "ncmsgs" */ './Types/DeviationMentionsUser')));
const GroupForumNotification = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "ncmsgs" */ './Types/GroupForumNotification')));
const ArtTheftReportNotification = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "ncmsgs" */ './Types/ArtTheftReportNotification')));
const PointsTransactionNotification = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "ncmsgs" */ './Types/PointsTransactionNotification')));
const CommentNotification = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "ncmsgs" */ './Types/CommentNotification')));
const DownloadSoldNotification = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "ncmsgs" */ './Types/DownloadSoldNotification')));
const PrintSoldNotification = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "ncmsgs" */ './Types/PrintSoldNotification')));
const RadomRecommendationNotification = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "ncmsgs" */ './Types/RadomRecommendationNotification')));
const GroupCreatedNotification = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "ncmsgs" */ './Types/GroupCreatedNotification')));
const GroupJoinedNotification = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "ncmsgs" */ './Types/GroupJoinedNotification')));
const GroupChangedRoleNotification = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "ncmsgs" */ './Types/GroupChangedRoleNotification')));
const GroupLeftNotification = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "ncmsgs" */ './Types/GroupLeftNotification')));
const GroupRemovedDeviationNotification = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "ncmsgs" */ './Types/GroupRemovedDeviationNotification')));
const GroupNoteNotification = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "ncmsgs" */ './Types/GroupNoteNotification')));
const GroupAnnouncementNotification = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "ncmsgs" */ './Types/GroupAnnouncementNotification')));
const CommissionRequestNotification = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "ncmsgs" */ './Types/CommissionRequestNotification')));
const BlogSubmissionAuthorNotification = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "ncmsgs" */ './Types/BlogSubmissionAuthorNotification')));
const BlogSubmissionGroupNotification = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "ncmsgs" */ './Types/BlogSubmissionGroupNotification')));
const GroupDeviationSubmissionRequestNotification = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "ncmsgs" */ './Types/GroupDeviationSubmissionRequestNotification')));
const GroupDeviationSubmissionRequestReceiptNotification = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "ncmsgs" */ './Types/GroupDeviationSubmissionRequestReceiptNotification')));
const ModelTagRequestNotification = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "ncmsgs" */ './Types/ModelTagRequestNotification')));
const ModelTagRequestReceiptNotification = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "ncmsgs" */ './Types/ModelTagRequestReceiptNotification')));
const GalleryBoughtNotification = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "ncmsgs" */ './Types/GalleryBoughtNotification')));
const GallerySoldNotification = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "ncmsgs" */ './Types/GallerySoldNotification')));
const MsCancelledNotification = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "ncmsgs" */ './Types/MsCancelledNotification')));
const MsBillingFailedNotification = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "ncmsgs" */ './Types/MsBillingFailedNotification')));
const MsCreatedToSubscriberNotification = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "ncmsgs" */ './Types/MsCreatedToSubscriberNotification')));
const CommissionReceiptNotification = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "ncmsgs" */ './Types/CommissionReceiptNotification')));
const ModerationReportRequestNotification = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "ncmsgs" */ './Types/ModerationReportRequestNotification')));
const ModerationReportNeedInfoNotification = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "ncmsgs" */ './Types/ModerationReportNeedInfoNotification')));
const MsCreatedToOwnerNotification = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "ncmsgs" */ './Types/MsCreatedToOwnerNotification')));
const FragmentsReplenishReceiptNotification = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "ncmsgs" */ './Types/FragmentsReplenishReceiptNotification')));
const CoreGiftedNotification = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "ncmsgs" */ './Types/CoreGiftedNotification')));
const AffiliationIncomingReceiptNotification = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "ncmsgs" */ './Types/AffiliationIncomingReceiptNotification')));
const AffiliationIncomingRequestNotification = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "ncmsgs" */ './Types/AffiliationIncomingRequestNotification')));
const AffiliationOutgoingReceiptNotification = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "ncmsgs" */ './Types/AffiliationOutgoingReceiptNotification')));
const AffiliationOutgoingRequestNotification = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "ncmsgs" */ './Types/AffiliationOutgoingRequestNotification')));
const RepliedNotification = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "ncmsgs" */ './Types/RepliedNotification')));
const GroupInvitationNotification = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "ncmsgs" */ './Types/GroupInvitationNotification')));
const GroupInvitationPermissionNotification = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "ncmsgs" */ './Types/GroupInvitationPermissionNotification')));
const GroupInvitationReceiptNotification = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "ncmsgs" */ './Types/GroupInvitationReceiptNotification')));
const GroupJoinRequestReceiptNotification = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "ncmsgs" */ './Types/GroupJoinRequestReceiptNotification')));
const GroupJoinRequestNotification = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "ncmsgs" */ './Types/GroupJoinRequestNotification')));
const CommentLikedNotification = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "ncmsgs" */ './Types/CommentLikedNotification')));
const FaveSubmissionOfferGroupNotification = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "ncmsgs" */ './Types/FaveSubmissionOfferGroupNotification')));
const DeviationSubmissionOfferGroupNotification = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "ncmsgs" */ './Types/DeviationSubmissionOfferGroupNotification')));
const DeviationSubmissionOfferArtistReceiptNotification = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "ncmsgs" */ './Types/DeviationSubmissionOfferArtistReceiptNotification')));
const MsPromotionDywNotification = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "ncmsgs" */ './Types/MsPromotionDywNotification')));
const MsUnsubscribedNotification = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "ncmsgs" */ './Types/MsUnsubscribedNotification')));
const AdoptablesOfferNotification = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "ncmsgs" */ './Types/AdoptablesOfferNotification')));
const AdoptablesOfferReceiptNotification = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "ncmsgs" */ './Types/AdoptablesOfferReceiptNotification')));
const AdoptableSoldNotification = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "ncmsgs" */ './Types/AdoptableSoldNotification')));
const AdoptableResoldNotification = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "ncmsgs" */ './Types/AdoptableResoldNotification')));
const AdoptableBoughtNotification = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "ncmsgs" */ './Types/AdoptableBoughtNotification')));
const AdoptableOfferAlertNotification = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "ncmsgs" */ './Types/AdoptableOfferAlertNotification')));
const AdoptableOfferEndedNotification = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "ncmsgs" */ './Types/AdoptableOfferEndedNotification')));
const AdoptablesGiftNotification = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "ncmsgs" */ './Types/AdoptablesGiftNotification')));
const AdoptablesGiftReceiptNotification = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "ncmsgs" */ './Types/AdoptablesGiftReceiptNotification')));
export function renderNotification(notification) {
    if (!isValidNotification(notification)) {
        return /*#__PURE__*/ React.createElement(ErrorNotification, {
            notification: notification
        });
    }
    switch(notification.type){
        case 'nc.new_watcher':
            return /*#__PURE__*/ React.createElement(WatchNotification, {
                notification: notification
            });
        case 'nc.fave':
            return /*#__PURE__*/ React.createElement(FaveNotification, {
                notification: notification
            });
        case 'nc.collect':
            return /*#__PURE__*/ React.createElement(CollectNotification, {
                notification: notification
            });
        case 'nc.private_collect':
            return /*#__PURE__*/ React.createElement(PrivateCollectNotification, {
                notification: notification
            });
        case 'nc.award_badge_given_on_comment':
            return /*#__PURE__*/ React.createElement(CommentBadgeAwardNotification, {
                notification: notification
            });
        case 'nc.award_badge_given_on_deviation':
            return /*#__PURE__*/ React.createElement(DeviationBadgeAwardNotification, {
                notification: notification
            });
        case 'nc.badge_given':
            return /*#__PURE__*/ React.createElement(BadgeNotification, {
                notification: notification
            });
        case 'nc.badge_levelled':
            return /*#__PURE__*/ React.createElement(BadgeLevelledNotification, {
                notification: notification
            });
        case 'nc.dd_to_author':
            return /*#__PURE__*/ React.createElement(DdToAuthorNotification, {
                notification: notification
            });
        case 'nc.dd_to_suggester':
            return /*#__PURE__*/ React.createElement(DdToSuggesterNotification, {
                notification: notification
            });
        case 'nc.comment_mentions_deviation':
            return /*#__PURE__*/ React.createElement(CommentMentionsDeviation, {
                notification: notification
            });
        case 'nc.comment_mentions_user':
            return /*#__PURE__*/ React.createElement(CommentMentionsUser, {
                notification: notification
            });
        case 'nc.deviation_mentions_deviation':
            return /*#__PURE__*/ React.createElement(DeviationMentionsDeviation, {
                notification: notification
            });
        case 'nc.deviation_mentions_user':
            return /*#__PURE__*/ React.createElement(DeviationMentionsUser, {
                notification: notification
            });
        case 'nc.points_transaction':
            return /*#__PURE__*/ React.createElement(PointsTransactionNotification, {
                notification: notification
            });
        case 'nc.comment':
            return /*#__PURE__*/ React.createElement(CommentNotification, {
                notification: notification
            });
        case 'nc.pcp_sold':
            return /*#__PURE__*/ React.createElement(DownloadSoldNotification, {
                notification: notification
            });
        case 'nc.print_sold':
            return /*#__PURE__*/ React.createElement(PrintSoldNotification, {
                notification: notification
            });
        case 'nc.group_forum':
            return /*#__PURE__*/ React.createElement(GroupForumNotification, {
                notification: notification
            });
        case 'nc.art_theft_report':
            return /*#__PURE__*/ React.createElement(ArtTheftReportNotification, {
                notification: notification
            });
        case 'nc.adoptable_offer':
            return /*#__PURE__*/ React.createElement(AdoptablesOfferNotification, {
                notification: notification
            });
        case 'nc.adoptable_offer_receipt':
            return /*#__PURE__*/ React.createElement(AdoptablesOfferReceiptNotification, {
                notification: notification
            });
        case 'nc.adoptable_sold':
            return /*#__PURE__*/ React.createElement(AdoptableSoldNotification, {
                notification: notification
            });
        case 'nc.adoptable_resold':
            return /*#__PURE__*/ React.createElement(AdoptableResoldNotification, {
                notification: notification
            });
        case 'nc.adoptable_bought':
            return /*#__PURE__*/ React.createElement(AdoptableBoughtNotification, {
                notification: notification
            });
        case 'nc.adoptable_offer_alert':
            return /*#__PURE__*/ React.createElement(AdoptableOfferAlertNotification, {
                notification: notification
            });
        case 'nc.adoptable_offer_ended':
            return /*#__PURE__*/ React.createElement(AdoptableOfferEndedNotification, {
                notification: notification
            });
        case 'nc.adoptable_gift':
            return /*#__PURE__*/ React.createElement(AdoptablesGiftNotification, {
                notification: notification
            });
        case 'nc.adoptable_gift_receipt':
            return /*#__PURE__*/ React.createElement(AdoptablesGiftReceiptNotification, {
                notification: notification
            });
        case 'nc.radom_recommendation':
            return /*#__PURE__*/ React.createElement(RadomRecommendationNotification, {
                notification: notification
            });
        case 'nc.group_created':
            return /*#__PURE__*/ React.createElement(GroupCreatedNotification, {
                notification: notification
            });
        case 'nc.group_joined':
            return /*#__PURE__*/ React.createElement(GroupJoinedNotification, {
                notification: notification
            });
        case 'nc.group_changed_role':
            return /*#__PURE__*/ React.createElement(GroupChangedRoleNotification, {
                notification: notification
            });
        case 'nc.group_left':
            return /*#__PURE__*/ React.createElement(GroupLeftNotification, {
                notification: notification
            });
        case 'nc.group_removed_deviation':
            return /*#__PURE__*/ React.createElement(GroupRemovedDeviationNotification, {
                notification: notification
            });
        case 'nc.group_note':
            return /*#__PURE__*/ React.createElement(GroupNoteNotification, {
                notification: notification
            });
        case 'nc.group_announcement':
            return /*#__PURE__*/ React.createElement(GroupAnnouncementNotification, {
                notification: notification
            });
        case 'nc.commission_request':
            return /*#__PURE__*/ React.createElement(CommissionRequestNotification, {
                notification: notification
            });
        case 'nc.deviation_submission_permission_group_receipt':
            return /*#__PURE__*/ React.createElement(GroupDeviationSubmissionRequestReceiptNotification, {
                notification: notification
            });
        case 'nc.deviation_submission_permission_request':
            return /*#__PURE__*/ React.createElement(GroupDeviationSubmissionRequestNotification, {
                notification: notification
            });
        case 'nc.blog_submission_author_receipt':
            return /*#__PURE__*/ React.createElement(BlogSubmissionAuthorNotification, {
                notification: notification
            });
        case 'nc.blog_submission_group_notification':
            return /*#__PURE__*/ React.createElement(BlogSubmissionGroupNotification, {
                notification: notification
            });
        case 'nc.model_tag_request':
            return /*#__PURE__*/ React.createElement(ModelTagRequestNotification, {
                notification: notification
            });
        case 'nc.model_tag_request_receipt':
            return /*#__PURE__*/ React.createElement(ModelTagRequestReceiptNotification, {
                notification: notification
            });
        case 'nc.gallery_bought':
            return /*#__PURE__*/ React.createElement(GalleryBoughtNotification, {
                notification: notification
            });
        case 'nc.gallery_sold':
            return /*#__PURE__*/ React.createElement(GallerySoldNotification, {
                notification: notification
            });
        case 'nc.ms.cancelled':
            return /*#__PURE__*/ React.createElement(MsCancelledNotification, {
                notification: notification
            });
        case 'nc.ms.billing_fail':
            return /*#__PURE__*/ React.createElement(MsBillingFailedNotification, {
                notification: notification
            });
        case 'nc.ms.created_to_subscriber':
            return /*#__PURE__*/ React.createElement(MsCreatedToSubscriberNotification, {
                notification: notification
            });
        case 'nc.commission_receipt':
            return /*#__PURE__*/ React.createElement(CommissionReceiptNotification, {
                notification: notification
            });
        case 'nc.moderation_report_request':
            return /*#__PURE__*/ React.createElement(ModerationReportRequestNotification, {
                notification: notification
            });
        case 'nc.ms.created_to_owner':
            return /*#__PURE__*/ React.createElement(MsCreatedToOwnerNotification, {
                notification: notification
            });
        case 'nc.fragments_replenish_receipt':
            return /*#__PURE__*/ React.createElement(FragmentsReplenishReceiptNotification, {
                notification: notification
            });
        case 'nc.core_gifted':
            return /*#__PURE__*/ React.createElement(CoreGiftedNotification, {
                notification: notification
            });
        case 'nc.moderation_report_need_info':
            return /*#__PURE__*/ React.createElement(ModerationReportNeedInfoNotification, {
                notification: notification
            });
        case 'nc.affiliation_incoming_receipt':
            return /*#__PURE__*/ React.createElement(AffiliationIncomingReceiptNotification, {
                notification: notification
            });
        case 'nc.affiliation_incoming_request':
            return /*#__PURE__*/ React.createElement(AffiliationIncomingRequestNotification, {
                notification: notification
            });
        case 'nc.affiliation_outgoing_receipt':
            return /*#__PURE__*/ React.createElement(AffiliationOutgoingReceiptNotification, {
                notification: notification
            });
        case 'nc.affiliation_outgoing_request':
            return /*#__PURE__*/ React.createElement(AffiliationOutgoingRequestNotification, {
                notification: notification
            });
        case 'nc.replied':
            return /*#__PURE__*/ React.createElement(RepliedNotification, {
                notification: notification
            });
        case 'nc.group_invitation':
            return /*#__PURE__*/ React.createElement(GroupInvitationNotification, {
                notification: notification
            });
        case 'nc.group_invitation_permission':
            return /*#__PURE__*/ React.createElement(GroupInvitationPermissionNotification, {
                notification: notification
            });
        case 'nc.group_invitation_receipt':
            return /*#__PURE__*/ React.createElement(GroupInvitationReceiptNotification, {
                notification: notification
            });
        case 'nc.group_join_request':
            return /*#__PURE__*/ React.createElement(GroupJoinRequestNotification, {
                notification: notification
            });
        case 'nc.group_join_request_receipt':
            return /*#__PURE__*/ React.createElement(GroupJoinRequestReceiptNotification, {
                notification: notification
            });
        case 'nc.comment_liked':
            return /*#__PURE__*/ React.createElement(CommentLikedNotification, {
                notification: notification
            });
        case 'nc.fave_submission_offer_group_notification':
            return /*#__PURE__*/ React.createElement(FaveSubmissionOfferGroupNotification, {
                notification: notification
            });
        case 'nc.deviation_submission_offer_group_notification':
            return /*#__PURE__*/ React.createElement(DeviationSubmissionOfferGroupNotification, {
                notification: notification
            });
        case 'nc.deviation_submission_offer_artist_receipt':
            return /*#__PURE__*/ React.createElement(DeviationSubmissionOfferArtistReceiptNotification, {
                notification: notification
            });
        case 'nc.ms.promotion_dyw':
            return /*#__PURE__*/ React.createElement(MsPromotionDywNotification, {
                notification: notification
            });
        case 'nc.ms.unsubscribed':
            return /*#__PURE__*/ React.createElement(MsUnsubscribedNotification, {
                notification: notification
            });
        default:
            return /*#__PURE__*/ React.createElement(ErrorNotification, {
                notification: notification
            });
    }
}
